// Header row in PipelineTable and the body row in PipelineRow must stay in
// sync. Keeping labels and template in one place removes a silent-drift
// hazard.
export type PipelineColumn = {
  label: string
  width: string
  align?: 'right'
}

export const PIPELINE_COLUMNS: readonly PipelineColumn[] = [
  { label: 'Pipeline', width: '100px' },
  { label: 'Status', width: '140px' },
  { label: 'Workflow', width: '110px' },
  { label: 'Checkout source', width: 'minmax(220px, 1.4fr)' },
  { label: 'Trigger event', width: '170px' },
  { label: 'Start', width: '90px' },
  { label: 'Duration', width: '110px' },
  { label: 'Actions', width: '140px', align: 'right' },
]

export const PIPELINE_GRID_COLUMNS = PIPELINE_COLUMNS.map(c => c.width).join(' ')
